/**
 * Syncs Rebel theme cart UI after PageFly (or other) add-to-cart requests
 * that do not dispatch ThemeEvents.cartUpdate ('cart:update').
 */
(function () {
  const CART_UPDATE = 'cart:update';
  const ADD_SUCCESS = 'ss:cart-add-success';
  const SOURCE = 'pagefly-cart-bridge';

  /** @param {Record<string, unknown>} cart */
  function dispatchCartUpdate(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    document.dispatchEvent(
      new CustomEvent(CART_UPDATE, {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: SOURCE,
          data: {
            source: SOURCE,
            itemCount: cart.item_count,
          },
        },
      })
    );
  }

  /** @param {unknown} payload */
  function notifyAddSuccess(payload) {
    document.dispatchEvent(
      new CustomEvent(ADD_SUCCESS, {
        bubbles: true,
        detail: { payload, source: SOURCE },
      })
    );
  }

  function syncCartFromServer() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (cart) dispatchCartUpdate(cart);
        return cart;
      })
      .catch(() => null);
  }

  /** @param {unknown} payload */
  function handleAddResponse(payload) {
    if (!payload || typeof payload !== 'object') {
      return syncCartFromServer().then((cart) => {
        if (cart) notifyAddSuccess(cart);
      });
    }

    if ('status' in payload && payload.status) return;

    if ('item_count' in payload && typeof payload.item_count === 'number') {
      dispatchCartUpdate(/** @type {Record<string, unknown>} */ (payload));
      notifyAddSuccess(payload);
      return;
    }

    syncCartFromServer().then((cart) => {
      notifyAddSuccess(payload);
      if (cart) dispatchCartUpdate(cart);
    });
  }

  /** @param {string} url */
  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function patchedFetch(input, init) {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
    const method = (
      init?.method ||
      (input instanceof Request ? input.method : undefined) ||
      'GET'
    ).toUpperCase();
    const isAdd = method === 'POST' && isCartAddUrl(url);

    return nativeFetch(input, init).then((response) => {
      if (isAdd && response.ok) {
        response
          .clone()
          .json()
          .then(handleAddResponse)
          .catch(() => syncCartFromServer().then((cart) => cart && notifyAddSuccess(cart)));
      }
      return response;
    });
  };

  const xhrProto = XMLHttpRequest.prototype;
  const nativeOpen = xhrProto.open;
  const nativeSend = xhrProto.send;

  xhrProto.open = function patchedOpen(method, url) {
    this.__pfCartBridge = { method: String(method || 'GET').toUpperCase(), url: String(url || '') };
    return nativeOpen.apply(this, arguments);
  };

  xhrProto.send = function patchedSend() {
    this.addEventListener('load', function onLoad() {
      const meta = this.__pfCartBridge;
      if (!meta || meta.method !== 'POST' || !isCartAddUrl(meta.url)) return;
      if (this.status < 200 || this.status >= 300) return;

      try {
        handleAddResponse(JSON.parse(this.responseText));
      } catch {
        syncCartFromServer().then((cart) => cart && notifyAddSuccess(cart));
      }
    });

    return nativeSend.apply(this, arguments);
  };

  document.addEventListener(
    'submit',
    function onProductFormSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('pf-product-form') && !form.action.includes('/cart/add')) return;

      window.setTimeout(syncCartFromServer, 800);
    },
    true
  );
})();
